import Exception from "src/utils/exception";
import Constants from "src/utils/constants";
import DBOperationsComb from "src/utils/dbOperationsComb";
import Helper from "@/utils/helper";

export function getMasterShops(config) {
  try {
    return DBOperationsComb.fetchData(
      {
        tableName: Constants.enums.TABLES_NAME_ENUM.MASTER_SHOPS_TABLE,
        fetchAll: true,
        ...config
      },
      true
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

export function getMasterRegions(config) {
  try {
    return DBOperationsComb.fetchData(
      {
        tableName: Constants.enums.TABLES_NAME_ENUM.MASTER_REGIONS_TABLE,
        fetchAll: true,
        ...config
      },
      true
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

export function getMasterCompanies(config) {
  try {
    return DBOperationsComb.fetchData(
      {
        tableName: Constants.enums.TABLES_NAME_ENUM.MASTER_COMPANIES_TABLE,
        fetchAll: true,
        ...config
      },
      true
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function subscribeToPermissions(callback) {
  return await DBOperationsComb.subscribeToDocument(
    Constants.enums.TABLES_NAME_ENUM.PROFILE_TABLE,
    Helper.getCurrentUserId(),
    callback
  );
}

export default {
  getMasterShops,
  getMasterRegions,
  getMasterCompanies,
  subscribeToPermissions
};
